import type { OrganizationPublic } from "@/client"
import { OrganizationsService } from "@/client"
import { getCurrentOrgId } from "@/utils"
import { useQuery, useQueryClient } from "@tanstack/react-query"

export function coerceFeedbackEnabled(settings: unknown): boolean {
  if (!settings || typeof settings !== "object") {
    return true
  }

  const value = (settings as { feedback_enabled?: unknown }).feedback_enabled
  return typeof value === "boolean" ? value : true
}

export function useFeedbackEnabled(): { enabled: boolean; isLoading: boolean } {
  const queryClient = useQueryClient()
  const currentOrgId = getCurrentOrgId()

  const cachedOrg = currentOrgId
    ? queryClient.getQueryData<OrganizationPublic>([
        "currentOrganization",
        currentOrgId,
      ])
    : undefined

  const { data: currentOrganization, isLoading } = useQuery({
    queryKey: ["currentOrganization", currentOrgId],
    queryFn: () =>
      OrganizationsService.getOrganization({ orgId: currentOrgId as string }),
    enabled: Boolean(currentOrgId),
    staleTime: 5 * 60 * 1000,
  })

  const enabled = coerceFeedbackEnabled(
    currentOrganization?.settings ?? cachedOrg?.settings,
  )

  return { enabled, isLoading: currentOrgId ? isLoading : false }
}
